module.exports = __webpack_public_path__ + "static/media/map1.5ca6fff5.png";